import { Flex } from '@chakra-ui/react';
import { checkDemoPredictiveScoreEnabled } from 'utils/helpers/featureFlags';

import BetaTag from 'uiToolkitV1/Tag/BetaTag';
import { TextLabel } from 'uiToolkitV1/Typography';

import { AGGRID_COLUMN_TYPES } from './dataHooks';

const CustomHeaderGroupComp = (props) => {
  // eslint-disable-next-line react/destructuring-assignment
  const { headerName = '', headerText = '', isBeta } = props?.columnGroup?.providedColumnGroup?.colGroupDef || {};
  return (
    <Flex className="ag-header-group-cell-label" flexDir="column" justify="center" alignItems="center">
      <Flex gap="8px">
        <TextLabel bold>{headerText}</TextLabel> {isBeta && <BetaTag />}
      </Flex>

      <TextLabel bold>{headerName}</TextLabel>
    </Flex>
  );
};

export const groupColumnDefinitionHeader = (colDef, calibrationViewId) => {
  const headerGroupCols = colDef.filter(({ columnType }) => columnType === AGGRID_COLUMN_TYPES.HEADER_GROUP);
  const otherCols = colDef.filter(({ columnType }) => columnType !== AGGRID_COLUMN_TYPES.HEADER_GROUP);
  const isFirstCalibrationView = calibrationViewId === '1';
  const groupColumnDefinition = [];

  otherCols.forEach((col) => {
    const parentColumnId = col?.parentColumnId;

    if (!parentColumnId) {
      groupColumnDefinition.push(col);
      return;
    }

    const currentCycleId = headerGroupCols.find(({ metadata }) => metadata.headerText === 'Current Cycle')?.colId;
    const currentCycleIdNumberArray = currentCycleId?.split('_');
    const currentCycleIdNumber = currentCycleIdNumberArray?.[currentCycleIdNumberArray.length - 1] ?? null;

    if (
      checkDemoPredictiveScoreEnabled() &&
      isFirstCalibrationView &&
      currentCycleId === parentColumnId &&
      col?.columnType === AGGRID_COLUMN_TYPES.REVIEW_STATUS
    ) {
      return;
    }
    const parentHeader = headerGroupCols.find(({ id }) => id === parentColumnId);
    const headerGroupCol = groupColumnDefinition.find(({ headerId }) => headerId === parentColumnId);
    if (!headerGroupCol) {
      groupColumnDefinition.push({
        headerName:
          checkDemoPredictiveScoreEnabled() &&
          isFirstCalibrationView &&
          parentHeader.metadata.headerText === 'Current Cycle'
            ? '(Off-cycle)'
            : parentHeader.displayName,
        headerClass: 'talent-planning-header-group',
        headerText:
          checkDemoPredictiveScoreEnabled() &&
          isFirstCalibrationView &&
          parentHeader.metadata.headerText === 'Current Cycle'
            ? 'Predictive score'
            : parentHeader.metadata.headerText,
        isBeta:
          (checkDemoPredictiveScoreEnabled() &&
            isFirstCalibrationView &&
            parentHeader.metadata.headerText === 'Current Cycle') ||
          parentHeader.id === 'PREDICTION_DATA',
        isCurrentCycle: parentHeader.metadata.headerText === 'Current Cycle',
        isFirstCalibrationView,
        marryChildren: true,
        headerGroupComponent: CustomHeaderGroupComp,
        processHeaderCallback: (params) => {
          const { children } = params;
          const { headerText } = children[0].data.metadata;
          const { displayName } = children[0].data;
          return `${headerText} (${displayName})`;
        },

        children: [
          {
            ...col,
            currentCycleIdNumber,
            isCurrentCycle: parentHeader.metadata.headerText === 'Current Cycle',
            isFirstCalibrationView,
          },
        ],

        // for search purposes by id
        headerId: parentHeader.id,
      });
    } else {
      const newCol = {
        ...col,
        currentCycleIdNumber,
        isCurrentCycle: parentHeader.metadata.headerText === 'Current Cycle',
        isFirstCalibrationView,
      };
      headerGroupCol.children.push(newCol);
    }
  });

  return groupColumnDefinition;
};

export const CALIBRATION_STATUS_VALUES = {
  PENDING: 'PENDING',
  NOT_REQUIRED: 'NOT_REQUIRED',
  COMPLETE: 'COMPLETE',
};

export const CALIBRATION_STATUS_LABELS = {
  [CALIBRATION_STATUS_VALUES.PENDING]: 'Pending',
  [CALIBRATION_STATUS_VALUES.NOT_REQUIRED]: 'Not Required',
  [CALIBRATION_STATUS_VALUES.COMPLETE]: 'Complete',
};

export const CALIBRATION_STATUS_COLORS = {
  [CALIBRATION_STATUS_VALUES.PENDING]: 'greySecondary',
  [CALIBRATION_STATUS_VALUES.NOT_REQUIRED]: 'greySecondary',
  [CALIBRATION_STATUS_VALUES.COMPLETE]: 'greenSecondary',
};
